import { useEffect, useState } from "react";
import axios from "axios";
import { BarChart3 } from "lucide-react";
import { API } from "../../../config";
import { formatEur } from "../../../pages/SmsCreditPage";

export const SmsCountryStats = () => {
  const [data, setData] = useState(null);
  useEffect(() => { axios.get(`${API}/admin/sms-credit/stats/per-country`).then((r) => setData(r.data)).catch(() => setData({ rows: [] })); }, []);
  if (!data) return null;
  return (
    <div className="bg-[#111] border border-gray-800 rounded-2xl p-6" data-testid="sms-country-stats">
      <p className="flex items-center gap-2 text-white font-semibold mb-1"><BarChart3 size={18} /> SMS medi per contratto firmato</p>
      <p className="text-xs text-gray-400 mb-4">OTP firma, link card e benvenuto inviati ai clienti con contratto firmato. Costo calcolato al listino attuale.</p>
      {data.rows.length === 0 ? (
        <p className="text-sm text-gray-500" data-testid="sms-country-stats-empty">Nessun contratto firmato ancora disponibile.</p>
      ) : (
        <table className="w-full text-sm">
          <thead className="text-xs uppercase text-gray-400 border-b border-gray-800">
            <tr><th className="text-left py-2">Paese</th><th className="text-right">Contratti</th><th className="text-right">SMS</th><th className="text-right">SMS / contratto</th><th className="text-right">Costo medio / contratto</th></tr>
          </thead>
          <tbody>
            {data.rows.map((r) => (
              <tr key={r.country} className="border-b border-gray-900" data-testid={`sms-stats-row-${r.country}`}>
                <td className="py-2 text-white font-semibold">{r.country}</td>
                <td className="text-right text-gray-300">{r.contracts}</td>
                <td className="text-right text-gray-300">{r.sms}</td>
                <td className="text-right text-white">{r.avg_sms_per_contract.toLocaleString("it-IT")}</td>
                <td className="text-right text-white">{formatEur(r.avg_cost_per_contract_eur, 3)}</td>
              </tr>
            ))}
            <tr className="font-semibold" data-testid="sms-stats-total">
              <td className="py-2 text-white">Totale</td><td className="text-right text-white">{data.total_contracts}</td>
              <td className="text-right text-white">{data.total_sms}</td><td className="text-right text-white">{data.avg_sms_per_contract.toLocaleString("it-IT")}</td><td />
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
};
